import axios from "axios";

export const settingsData = () => {
    return axios
      .get("/settings")
      .then((response) => {
        // console.log(response.data);
        return response;
      });
  };